// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"26fa4c94","453":"0e84fa6c","455":"d87ef649","806":"81ce976b","977":"ccb444a6"}[chunkId] + ".chunk.js";
};